import { secureGet, securePost, securePut, secureDelete } from '../utils/HttpUtils';
import { ReferrerName } from '../types/interfaces';

const apiUrls = {
  referrerNames: '/v1/private/referrer-names',
};

const mapReferrerName = (item: any): ReferrerName => ({
  id: item.id,
  code: item.code,
  name: item.name,
  cuit: item.cuit ?? null,
  commissionPercentage: item.commissionPercentage ?? item.commission_percentage ?? null,
  enabled: item.enabled ?? true,
});

export const getReferrerNames = async (): Promise<{
  success: boolean;
  data?: ReferrerName[];
  message?: string;
  status?: number;
}> => {
  try {
    const response = await secureGet(apiUrls.referrerNames);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: (response.data as any[]).map(mapReferrerName),
      };
    }
    return {
      success: false,
      message: 'Error al obtener los referidos',
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message: 'Error al obtener los referidos',
    };
  }
};

export const getAllReferrerNames = async (): Promise<{
  success: boolean;
  data?: ReferrerName[];
  message?: string;
  status?: number;
}> => {
  try {
    const response = await secureGet(`${apiUrls.referrerNames}?all=true`);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: (response.data as any[]).map(mapReferrerName),
      };
    }
    return {
      success: false,
      message: 'Error al obtener los referidos',
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message: 'Error al obtener los referidos',
    };
  }
};

export const createReferrerName = async (
  name: string,
  code: string,
  cuit?: string | null,
  commissionPercentage?: number | null,
): Promise<{
  success: boolean;
  data?: ReferrerName;
  message?: string;
  status?: number;
}> => {
  try {
    const body: any = { name, code };
    if (cuit) body.cuit = cuit;
    if (commissionPercentage !== null && commissionPercentage !== undefined) {
      body.commission_percentage = commissionPercentage;
    }
    const response = await securePost(apiUrls.referrerNames, body);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: response.data as ReferrerName,
      };
    }
    return {
      success: false,
      message: response.message || 'Error al crear el referido',
      status: response.status,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al crear el referido',
    };
  }
};

export const updateReferrerName = async (
  id: number,
  name: string,
  code: string,
  cuit?: string | null,
  commissionPercentage?: number | null,
  enabled?: boolean,
): Promise<{
  success: boolean;
  data?: ReferrerName;
  message?: string;
  status?: number;
}> => {
  try {
    const url = `${apiUrls.referrerNames}/${id}`;
    const body: any = { name, code };
    if (cuit !== undefined) body.cuit = cuit || null;
    if (commissionPercentage !== null && commissionPercentage !== undefined) {
      body.commission_percentage = commissionPercentage;
    }
    if (enabled !== undefined) body.enabled = enabled;
    const response = await securePut(url, body);
    if (response.success && 'data' in response) {
      return {
        success: true,
        data: response.data as ReferrerName,
      };
    }
    return {
      success: false,
      message: response.message || 'Error al actualizar el referido',
      status: response.status,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al actualizar el referido',
    };
  }
};

export const deleteReferrerName = async (
  id: number,
): Promise<{
  success: boolean;
  message?: string;
  status?: number;
}> => {
  try {
    const url = `${apiUrls.referrerNames}/${id}`;
    const response = await secureDelete(url);
    if (response.success) {
      return { success: true };
    }
    return {
      success: false,
      message: response.message || 'Error al dar de baja el referido',
      status: response.status,
    };
  } catch (error: any) {
    return {
      success: false,
      message: 'Error al dar de baja el referido',
    };
  }
};
